export default __webpack_public_path__ + "static/media/photo--lg--christina-3.206dff20.jpg";